import { useUnit } from 'effector-react';
import { Typography } from '@mui/material';
import i18n from '@shared/config/i18n';
import { SelectControl, SelectField } from '@ui/index';
import {
  findContacts,
  $isContactsLoading,
  clearSearchedContacts,
  $searchedContactsArr,
} from '../../models';

const { t } = i18n;

const getOptionValue = (option: any) => option.id;

const ContactsSelect = (props: any) => {
  const searchedContactsArr = useUnit($searchedContactsArr);
  const isLoading = useUnit($isContactsLoading);

  const handleInputChange = (input: string) => {
    clearSearchedContacts();
    findContacts(input);
    return input;
  };

  const onMenuClose = () => {
    clearSearchedContacts();
  };

  return (
    <SelectControl
      label={props?.hideLabel ? null : t('Contact')}
      placeholder={props?.placeholder ?? t('EnterTheContactNameOrAddress')}
      getOptionValue={getOptionValue}
      formatOptionLabel={(option, { context }) =>
        context === 'menu' ? (
          <div>
            <Typography color="textPrimary" variant="body2">
              {option.name}
            </Typography>
            <Typography color="textSecondary" variant="body2">
              {option.role === 'mc_manager' ? t('Employee') : option.address}
            </Typography>
          </div>
        ) : (
          option.name
        )
      }
      options={searchedContactsArr}
      onInputChange={handleInputChange}
      filterOption={() => true}
      onMenuClose={onMenuClose}
      isLoading={isLoading}
      {...props}
    />
  );
};

const ContactsSelectField = (props: any) => {
  const onChange = (value: any) => props.form.setFieldValue(props.field.name, value);

  return <SelectField component={<ContactsSelect />} onChange={onChange} {...props} />;
};

export { ContactsSelect, ContactsSelectField };
